/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav P�ibyl (pribyl@cadwork.cz)
 *
 */

import RenderDocument from "App/render_document";
import View from "App/view/view";
import ExaminerControls from "App/view/controls/examiner_controls";
import {EViewControlsFamily} from "js_interface/src/modules/view_controls/scene_view_controls_enums";

/**
 * Controls behaviour for animated view around Y axis (inspired by https://www.verold.com/projects/54fd8808c31d4eb07cbc1f3d)
 *
 * @param {object} aDocument render document
 * @param {object} aView view instance
 *
 * TODO: handle in application
 * create something like SceneAPI::startAnimation(from, to, duration, ...) or SceneAPI::startRotation(object, axis, speed, ...)
 */
export default
class YAnimationControls extends ExaminerControls {
    constructor(aDocument: RenderDocument, aView: View) {
        super(aDocument, aView);
        this._family = EViewControlsFamily.YANIMATION;
    }

    public tick(): void {
        super.tick();
    }
}
